import { useEffect, useState } from "react";
import axios from "axios";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";
import BoardWorkspace from "@/components/BoardWorkspace";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/operations`;

export default function ProjectActivityHistoryPage() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const load = async (term = "") => {
    const response = await axios.get(`${API}/project-activity`, { params: { search: term } });
    setRows(response.data.rows);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <BoardWorkspace
      eyebrow="Company project audit"
      headingTestId="project-activity-heading"
      subtitle="Every visible project change and the user who made it."
      title="Activity History"
    >
      <section className="closed-projects-toolbar" data-testid="project-activity-toolbar">
        <Search size={16} />
        <input
          data-testid="project-activity-search"
          onChange={(event) => {
            setSearch(event.target.value);
            load(event.target.value);
          }}
          placeholder="Search project, action, user"
          value={search}
        />
        <span>{rows.length} events</span>
      </section>
      <section className="activity-history-list" data-testid="project-activity-list">
        {rows.map((row) => (
          <article data-testid={`project-activity-${row.id}`} key={row.id}>
            <Link data-testid={`project-activity-project-${row.id}`} to={`/projects/${row.project_id}`}>
              {row.project_code || row.project_name}
            </Link>
            <strong data-testid={`project-activity-action-${row.id}`}>{row.action}</strong>
            <span data-testid={`project-activity-detail-${row.id}`}>
              {row.reason || row.source || "Project activity"}
            </span>
            <small data-testid={`project-activity-actor-${row.id}`}>
              {row.actor_name} · {row.actor_role} · {row.occurred_at}
            </small>
          </article>
        ))}
      </section>
    </BoardWorkspace>
  );
}